import { z } from 'zod/v4';

export const DashboardVariableOptionDTO = z.object({
  value: z.string().min(1),
  label: z.string().optional(),
});
export type DashboardVariableOption = z.infer<
  typeof DashboardVariableOptionDTO
>;

export const DashboardVariableDTO = z.object({
  name: z.string().regex(/^[A-Za-z][A-Za-z0-9_]*$/),
  type: z.enum(['select', 'text']).optional(),
  multi: z.boolean(),
  options: z.array(DashboardVariableOptionDTO),
});
export type DashboardVariable = z.infer<typeof DashboardVariableDTO>;

export const DashboardVariableValuesDTO = z.record(
  z.string(),
  z.union([z.string(), z.array(z.string())]),
);
export type DashboardVariableValues = z.infer<
  typeof DashboardVariableValuesDTO
>;